import { useEffect, useState } from "react";
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress, Box, Tooltip, Typography, Autocomplete, } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { addSubleaseApi, editSubleaseApi } from "../apiServices";
import { globalPostService, globalPutService } from "../../../../utils/globalApiServices";
import { checkApiStatus } from "../../../../utils";
import { useSnackbar } from "notistack";
import moment from "moment";
import { AttachementsUpload } from "../../../../shared_elements/components";
import { useParams } from "react-router-dom";
import { backendDateFormat, fieldDateFormat } from "../../../../constants";
import { setFileUploadDetails } from "../../../../shared_elements/actions";
import { useDispatch, useSelector } from "react-redux";
import { trackActivity } from "../../../../utils/mixpanel";
import { formatBytes } from '../../../../utils/fileUpload';
import { regexConstants } from "../../../../constants/regEx";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";
import { getLesseeApi } from "../../../../shared_elements/actionCreators";
import { gaTelesisInstance } from "../../../../shared_elements";

const SubleaseCRU = ({ addEditSublease, modeType,fileUpload, getResponseBack, onToggleModal, onOpenAttachments }) => {
    const {storageDetails, lessee} = useSelector((state) => state.leases);
    const params = useParams()
    const dispatch=useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(addEditSublease?.data);
    const [error, setError] = useState({});
    const [attachments, setAttachments] = useState([]);
    const [isDropDownLoading, setIsDropDownLoading] = useState({});

    useEffect(() => {
        if (gaTelesisInstance && !lessee?.length && modeType !== "view") {
            setIsDropDownLoading(prev => ({ ...prev, lessee: true }));
            dispatch(getLesseeApi({ setIsDropDownLoading }));
        }
    }, []);

    const onRestErrorKey = (key) => {
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value });
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({attachments:files}))
    };


    const onAddEditSubLease = () => {
        const validationInputs = {
            sublease_lessee: data?.sublease_lessee ? "" : "Please enter Name",
        };
        if (gaTelesisInstance) {
            validationInputs.start_date = data?.start_date ? "" : "Please select Start Date";
            validationInputs.end_date = data?.end_date ? "" : "Please select End Date";
        }

        const startDate = moment(data?.start_date);
        const endDate = moment(data?.end_date);
        if (data?.start_date && data?.end_date) {
            if (endDate.isBefore(startDate)) {
                validationInputs.end_date = "End date cannot be before start date";
            }
            if (startDate.isAfter(endDate)) {
                validationInputs.start_date = "Start date cannot be after end date";
            }
            if(data.start_date && !startDate.isValid()) {
                validationInputs.start_date = "Please enter valid Start Date";
            } 
            if(data.end_date && !endDate.isValid()) {
                validationInputs.end_date = "Please enter valid End Date";
            }
        }

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            const payload = gaTelesisInstance ? { ...data, sublessee_config: data?.sublessee_config?.id || null } : data;
            if (data.id) {
                globalPutService(editSubleaseApi({ ...params, slug: data?.slug }), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(data?.slug,'updated')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Sublease`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Sublease`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    }
                });
            } else {

                globalPostService(addSubleaseApi(params), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'created')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Add Sublease`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Sublease`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Sublease`, error_msg: validationInputs, })
        }
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Sublease`, page_type: page_type, })
    }

    return (
        <>
            <Dialog
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onToggleModal();
                    }
                }}
                disableEscapeKeyDown
                aria-labelledby="customized-dialog-title"
                className="add-lease-dialog"
                maxWidth="md"
                fullWidth
                open={addEditSublease?.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {data?.id ? `${addEditSublease?.mode === "view" ? "View" : "Edit" } Sublease` : "Add Sublease"}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Tooltip title={data?.sublease_lessee.length > 23 ? data?.sublease_lessee : ""} placement="bottom" arrow >
                                <TextField
                                    disabled={addEditSublease?.mode === "view"}
                                    required
                                    id="sublease_lessee"
                                    label="Name"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                                    value={data?.sublease_lessee || ""}
                                    onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("sublease_lessee", e.target.value.trimStart()) : e.preventDefault()}
                                    onFocus={() => onRestErrorKey("sublease_lessee")}
                                    error={Boolean(error.sublease_lessee)}
                                    helperText={error.sublease_lessee}
                                    fullWidth
                                />
                            </Tooltip>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    disabled={addEditSublease.mode === "view"}
                                    label="Start Date"
                                    value={data?.start_date ? moment(data.start_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("start_date", data ? moment(data).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("start_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            required: gaTelesisInstance,
                                            size: "small",
                                            margin: "normal",
                                            error: error.start_date || false,
                                            helperText: error.start_date || '',
                                            onFocus: () => {error.start_date && onRestErrorKey("start_date");}
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("start_date", null);
                                                onRestErrorKey("start_date");
                                            }
                                        }
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    disabled={addEditSublease.mode === "view"}
                                    label="End Date"
                                    value={data?.end_date ? moment(data.end_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("end_date", data ? moment(data).format(backendDateFormat) : null)
                                        if (isValid) {
                                            onRestErrorKey("end_date");
                                        }
                                    }}
                                    minDate={data?.start_date ? moment(data.start_date) : null}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            required: gaTelesisInstance,
                                            size: "small",
                                            margin: "normal",
                                            error: error.end_date || false,
                                            helperText: error.end_date || '',
                                            onFocus: () => { error.end_date && onRestErrorKey("end_date"); }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("end_date", null);
                                                onRestErrorKey("end_date");
                                            }
                                        }
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                />
                            </LocalizationProvider>
                        </Grid>
                        {gaTelesisInstance &&
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    disabled={addEditSublease?.mode === "view"}
                                    options={lessee || []}
                                    getOptionLabel={(option) => option?.name || ""}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    noOptionsText={isDropDownLoading?.lessee ? "Loading..." : "No Option Available"}
                                    value={data?.sublessee_config || null}
                                    onChange={(e, value) => onFieldChange("sublessee_config", value ? { id: value?.id, name: value?.name || '' } : null)}
                                    renderInput={(params) => {
                                        const selectedLabel = params?.inputProps?.value || "";
                                        return (
                                            <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                                <TextField
                                                    {...params}
                                                    label="Sub Lessee"
                                                    margin="normal"
                                                    size="small"
                                                    placeholder="Select Sub Lessee"
                                                    slotProps={{ ...params.slotProps, inputLabel: { shrink: true } }}
                                                />
                                            </Tooltip>
                                        );
                                    }}
                                />
                            </Grid>
                        }
                        {modeType === 'view' ?
                            <Grid item size={{ md: 12, xs: 12 }}>
                                <LessMoreTextFieldComp label='Details' value={data?.details || ""} />
                            </Grid>
                            : <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id="details"
                                    label="Details"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    value={data?.details || ""}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("details", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, details: "" }));
                                    }}
                                    multiline
                                    rows={3}
                                    fullWidth
                                />

                            </Grid>}
                        {modeType === 'view' ?
                            <Grid item size={{ md: 12, xs: 12 }}>
                                <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} />
                            </Grid>
                            : <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    fullWidth
                                    label="Remarks"
                                    name="remarks"
                                    aria-label="Remarks"
                                    value={data?.remarks || ""}
                                    multiline
                                    rows={3}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, remarks: "" }));
                                    }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                />
                            </Grid>}
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                                {data?.id && data?.attachments?.length ?
                                    <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({addEditSublease?.data?.attachments?.length})Attachment(s)</Button> : null
                                }
                                <Button className="available-space-btn" disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className="cancel-btn" disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : <Button variant="contained" size="small" className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditSubLease() }}> {isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
                </DialogActions>
            </Dialog>
        </>
    );
};
export default SubleaseCRU;